<template>
  <b-modal
    ref="game-tag-modal"
    hide-footer
    :title="modalTitle"
    @show="resetModal"
    @hidden="resetModal"
  >
    <form
      id="game-tag-form"
      ref="form"
      @submit.stop.prevent="handleSubmit"
    >
      <b-form-group
        label="ชื่อแท็ก"
        label-class="text-primary"
      >
        <b-form-input
          id="input-tag-name"
          v-model="input.name"
          type="text"
          placeholder="ชื่อแท็ก"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label="เรียงลำดับ"
        label-class="text-primary"
      >
        <b-form-input
          id="input-tag-sort"
          v-model="input.sort"
          type="text"
          placeholder="เรียงลำดับ"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label="Icon"
        label-class="text-primary"
      >
        <b-form-input
          id="input-tag-icon"
          v-model="input.icon"
          type="text"
          placeholder="fa-solid fa-slot-machine fa-xl"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label="Url รูปหน้าปก"
        label-class="text-primary"
      >
        <b-form-input
          id="input-creator-image"
          v-model="input.image"
          type="text"
          placeholder="https://example.com/image.jpg"
        ></b-form-input>
      </b-form-group>

      <b-form-group label="สถานะ" v-slot="{ ariaDescribedby }">
        <b-form-radio-group
          id="radio-status"
          v-model="input.status"
          :options="statusOptions"
          :aria-describedby="ariaDescribedby"
          name="radio-options"
        ></b-form-radio-group>
      </b-form-group>

      <div class="d-flex justify-content-end mt-3 pt-3">
        <b-button variant="link" size="sm" class="text-secondary mr-3" @click="hideModal">ยกเลิก</b-button>
        <b-button type="submit" variant="primary" size="sm" :disabled="isProcess || !input.name">{{isProcess ? 'กำลังบันทึก...' : 'บันทึก'}}</b-button>
      </div>
    </form>
  </b-modal>
</template>
<script>
import GameService from '@/services/gameService'
import Swal from 'sweetalert2'

export default {
  name: 'GameTagModal',
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: {
        _id: null,
        name: null,
        sort: 0,
        status: 'Active',
        icon: null,
        image: null
      }
    }
  },
  data() {
    return {
      input: {
        _id: null,
        name: null,
        sort: 0,
        status: 'Active',
        icon: null,
        image: null
      },
      isProcess: false,
      needReload: false
    }
  },
  computed: {
    modalTitle() {
      return this.input._id ? 'แก้ไขแท็กเกม' : 'เพิ่มแท็กเกม'
    },
    statusOptions() {
      return [
        { text: 'ใช้งาน', value: 'Active' },
        { text: 'ไม่ใช้งาน', value: 'Inactive' }
      ]
    }
  },
  watch: {
    isShow() {
      if(this.isShow){
        this.showModal()
      }else{
        this.hideModal()
      }
    },
    data() {
      this.input = JSON.parse(JSON.stringify(this.data))
    }
  },
  methods: {
    resetModal() {
      this.needReload = false
    },
    showModal() {
      this.$refs['game-tag-modal'].show()
    },
    hideModal() {
      this.$refs['game-tag-modal'].hide()
    },
    handleSubmit() {
      if(this.input._id) {
        this.update()
      }else{
        this.save()
      }
    },
    save() {
      if(this.input.name) {
        GameService.saveTag(this.input)
        .then((response)=>{

          console.log(response)
          if(response.success) {
            this.needReload = true
            this.hideModal()
          }else{
            throw new Error(response?.message)
          }
        })
        .catch((e)=>{

          Swal.fire({
            title: 'ผิดพลาด!',
            text: e?.message || 'บันทึกข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
            icon: 'error',
            confirmButtonText: 'OK'
          })
        })
      }
    },
    update() {
      if(this.input.name) {
        GameService.updateTag(this.input._id, this.input)
        .then((response)=>{
          console.log(response)
          if(response.success) {
            this.needReload = true
            this.hideModal()
            this.$notify({
              type: 'success',
              title: 'สำเร็จ!',
              text: 'บันทึกเสร็จเรียบร้อย',
            })
          }else{
            throw {
              massage: response
            }
          }
        })
        .catch((e)=>{
          Swal.fire({
            title: 'ผิดพลาด!',
            text: 'บันทึกข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
            icon: 'error',
            confirmButtonText: 'OK'
          })
        })
      }
    }
  },
  mounted() {
    this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
      this.$emit('close', this.needReload)
    })
  }
}
</script>
